import { render, staticRenderFns } from "./TechMarquee.vue?vue&type=template&id=6ededefa&scoped=true"
import script from "./TechMarquee.vue?vue&type=script&lang=js"
export * from "./TechMarquee.vue?vue&type=script&lang=js"
import style0 from "./TechMarquee.vue?vue&type=style&index=0&id=6ededefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ededefa",
  null
  
)

export default component.exports